import { type TFunction } from 'i18next';

import { TalentDTOType } from '@/api/generated';

export const getProcessTypes = (t: TFunction) => [
  { label: t('filters.options.processTypes.internal'), value: 'internal' },
  { label: t('filters.options.processTypes.external'), value: 'external' }
];

export const getTalentTypes = (t: TFunction) => [
  { label: t('filters.options.talentTypes.candidate'), value: TalentDTOType.CANDIDATE },
  { label: t('filters.options.talentTypes.employee'), value: TalentDTOType.EMPLOYEE }
];

export const getTalentLimited = (t: TFunction) => [
  { label: t('filters.options.limitedTalent.locked'), value: 'locked' },
  { label: t('filters.options.limitedTalent.blocked'), value: 'blocked' }
];

export const getTalentScores = (t: TFunction) => [
  { label: t('filters.options.talentScores.excellent'), value: 'a' },
  { label: t('filters.options.talentScores.good'), value: 'b' },
  { label: t('filters.options.talentScores.soSo'), value: 'c' },
  { label: t('filters.options.talentScores.acceptable'), value: 'd' },
  { label: t('filters.options.talentScores.bad'), value: 'e' },
  { label: t('filters.options.talentScores.horrible'), value: 'f' }
];

export const getHiringDecisions = (t: TFunction) => [
  { label: t('filters.options.hiringDecisions.accepted'), value: 'accepted' },
  { label: t('filters.options.hiringDecisions.rejected'), value: 'rejected' }
];

export const getProcessFeatures = (t: TFunction) => [
  { label: t('filters.sections.process.features.cameraOn'), value: 'CAMERA_ON' },
  { label: t('filters.sections.process.features.aiWebcam'), value: 'AI_WEBCAM' },
  { label: t('filters.sections.process.features.publicLink'), value: 'PUBLIC_LINK' },
  { label: t('filters.sections.process.features.limited'), value: 'LIMITED' }
];
